import React from "react";

import { performLogout } from "../../../lib/userUtils";
import { Text } from "../../../styles/utility-components";
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuSeperator,
  DropdownMenuTrigger,
} from "../../ui/dropdown_menu";
import Tooltip from "../../ui/tooltip/Tooltip";

type TeamDropdownProps = {
  onOpenChange?: (open: boolean) => void;
};

function TeamDropdown({ onOpenChange }: TeamDropdownProps) {
  const teamName = window.currentUser?.team.name;

  if (!teamName) {
    return null;
  }

  return (
    <DropdownMenu
      onOpenChange={onOpenChange}
      trigger={
        <DropdownMenuTrigger buttonStyle="inverse" buttonType="primary">
          <Tooltip content={teamName} side="bottom">
            <Text ellipsis ellipsisMethod="lineClamp">
              {teamName}
            </Text>
          </Tooltip>
        </DropdownMenuTrigger>
      }
    >
      <DropdownMenuItem
        key="account-settings"
        as="a"
        icon="settings01"
        href="/account-management/subscription"
      >
        Account settings
      </DropdownMenuItem>
      <DropdownMenuItem
        key="notification-settings"
        as="a"
        icon="bell03"
        href="/account-management/notifications"
      >
        Notification settings
      </DropdownMenuItem>
      <DropdownMenuItem key="manage-team" as="a" icon="users01" href="/account-management/my-team">
        Manage Team
      </DropdownMenuItem>
      <DropdownMenuSeperator key="separator" />
      <DropdownMenuItem key="logout" icon="logOut01" onClick={() => performLogout()}>
        Logout
      </DropdownMenuItem>
    </DropdownMenu>
  );
}

export default TeamDropdown;
